var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJobTabIconJobFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12467 17.4168H11.8747C15.833 17.4168 17.4163 15.8335 17.4163 11.8752V7.12516C17.4163 3.16683 15.833 1.5835 11.8747 1.5835H7.12467C3.16634 1.5835 1.58301 3.16683 1.58301 7.12516V11.8752C1.58301 15.8335 3.16634 17.4168 7.12467 17.4168Z",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13574 9.50018L8.37616 11.7406L12.8649 7.25977",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJobTabIconJobFields);
export default __webpack_public_path__ + "static/media/create_job_tab_icon_job_fields.fff5281cddb867ff34562521f11fdaec.svg";
export { ForwardRef as ReactComponent };